import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash-es';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../../Assests/AppConstant'
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { getPoSSselector } from '../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import { usePrevious } from '../../../../../../Common/CustomHooks/usePrevious';
import './AllAppointmentsListSS.css';
import moment from 'moment-timezone';
import DrilldownTableSS from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import WarehouseSearchSS from '../../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import { CustomPaginationSS } from '../../../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { smartScheduleSelector } from '../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { getRemoteConfigSelector } from '../../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import DownloadSectionBECustomFeilds from '../../../../DownloadSection/DownloadSectionBECustomFeilds';
import CustomDropDown from '../../../../../../Common/CustomDropDown/CustomDropDown';
import AppointmentReportHistory from './Components/AppointmentReportHistory';
import ModalSS from '../../../../../../SmartSchedule/SchedulePro/Components/Common/ModalSS/ModalSS';
import UploadSproDocumentsPopup from '../../../../../../Common/UploadSproDocumentsPopup/UploadSproDocumentsPopup';
import SSPopup from '../../../../../../Common/Popup/SSPopup/SSPopup';
import PoDetailsPopup from '../../../../../../Common/PoDetailsPopup/PoDetailsPopup';
import AppointmentReportSummarySubHeader from './Components/AppointmentReportSummarySubHeader';
import { shouldHavePermission } from '../../../../../../../Assests/Utility';
import WarehouseFiltersForReports from './Components/WarehouseFiltersForReports';
import { getLocalDateString } from '../../../../../../../../Utils/DateUtils';


const RescheduleLiveAppointment = (props) => {
    const { themeSelected = 'light-mode' } = props;
    const dispatch = useDispatch();
    const [allApptsArr, setAllApptsArr] = useState([]);
    const pOSS = useSelector(getPoSSselector);
    const { myAppointmentsList, arrangeOrder, arrangeKey, myAppointmentsListResponse, apptsReportHistoryList, isLoading } = pOSS;
    const userObj = useSelector(getUserSelector);
    const [searchStr, setSearchStr] = useState(null);
    const { selectedWarehouse, userType, userAccountDetails, permissions } = userObj;
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const divRef = useRef(null);
    const [showLoading, setShowLoading] = useState(true);
    const previousTable = usePrevious(currentTable);
    const ss = useSelector(smartScheduleSelector);
    const { isDownloadLoading, initateLoading, appointmentDocumentsList, isActiveCommanDownloadPopup, commanDownloadMessage } = ss;
    moment.tz.setDefault(selectedWarehouse?.TimeZone);
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration;
    const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'All User' });
    const [showAppointmentHistoryModal, setShowAppointmentHistoryModal] = useState(false);
    const [apptNumber, setapptNumber] = useState(null);
    const [showUploadDocsModal, setShowUploadDocsModal] = useState(false);
    const [popupshowMorePoObj, setPopupshowMorePoObj] = useState(null);
    const [showPoDetailsModal, setShowPoDetailsModal] = useState(false);
    const [selectedPo, setSelectedPo] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        return d;
    });
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected] = useState(null);
    const [downloadWarehouseFilterSelected, setDownloadWarehouseFilterSelected] = useState(null);
    const [allowPermission, setAllowPermission] = useState(false);
    const [dateRangeMode, setDateRangeMode] = useState('last30'); // 'last30' | 'last60' | 'custom'

    useEffect(() => {
        if (permissions.length) {
            const warehouseManagementPermission = _.find(permissions, { 'FeatureID': '12', 'PageAccess': true });
            if (warehouseManagementPermission && !_.isEmpty(warehouseManagementPermission)) {
                let temp = shouldHavePermission(permissions, '1000');
                setAllowPermission(temp)
                if (temp) {
                    if (selectedWarehouse) {
                        const warehouseName = selectedWarehouse.ExternalSiteID
                            ? `${selectedWarehouse.ExternalSiteID} - ${selectedWarehouse.Name}`
                            : selectedWarehouse.Name;
                        setCurrentWarehouseFilterSelected({ ID: selectedWarehouse.ID, name: warehouseName })
                        setDownloadWarehouseFilterSelected({ ID: selectedWarehouse.ID, name: warehouseName })
                    }
                    else {
                        setCurrentWarehouseFilterSelected({ ID: null, name: 'All Warehouse' })
                        // For non-super-admin: default to current logged-in warehouse

                        setDownloadWarehouseFilterSelected({ ID: null, name: 'All Warehouse' })
                    }
                }
            }
        }
    }, [permissions]);

    // Update dates when dateRangeMode changes
    useEffect(() => {
        if (dateRangeMode === 'last30') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 30);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'last60') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 60);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'custom') {
            // Default to next 7 days when choosing custom date range
            const today = new Date();
            const end = new Date();
            end.setDate(end.getDate() + 7);
            setSelectedStartDate(today);
            setSelectedEndDate(end);
        }
    }, [dateRangeMode]);

    useEffect(() => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
        return () => {
            dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
        };
    }, []);

    useEffect(() => {
        if (showUploadDocsModal) {
            fetchUploadDocsDataForAppt();
        }
    }, [showUploadDocsModal]);

    useEffect(() => {
        if (isActiveCommanDownloadPopup) {
            const popupObj = {
                id: 'popupshowMorePoObj',
                modalLabel: 'showMorePo',
                showClose: true,
                showfooter: true,
                showHeader: true,
                sendDriverNotification: false,
                modalSize: 'md',
                title: AppConstant.reports.downloadReportPopup.title,
                bodyText: (
                    <div>
                        <div>{commanDownloadMessage}</div>
                        <p className='mt-2 mb-0'>{AppConstant.reports.downloadReportPopup.hintPrefix}<strong>{AppConstant.reports.downloadReportPopup.myReportsBtn}</strong>{AppConstant.reports.downloadReportPopup.hintSuffix}</p>
                    </div>
                ),
                subText: "",
                keyboard: false,
                backdrop: "static",
                footerBtn: {
                    btn1: {
                        show: true,
                        text: 'My Reports'
                    },
                    btn2: {
                        show: true,
                        text: AppConstant.commonStrings.close
                    }
                },
            };
            setPopupshowMorePoObj({ ...popupObj });
        } else {
            setPopupshowMorePoObj(null);
        }
    }, [isActiveCommanDownloadPopup]);

    /**
     * useEffect to set start date in redux
     */
    useEffect(() => {
        if (selectedStartDate) {
            dispatch({ type: sagaActions.UPDATE_START_DATE, payload: new Date(selectedStartDate) });
            dispatch({ type: sagaActions.UPDATE_END_DATE, payload: null });
        }
    }, [selectedStartDate]);

    /**
     * useEffect to set end date in redux
     */
    useEffect(() => {
        if (selectedEndDate) {
            dispatch({ type: sagaActions.UPDATE_END_DATE, payload: new Date(selectedEndDate) });
        }
    }, [selectedEndDate]);

    const isValidRange = () => {
        if (!selectedStartDate || !selectedEndDate) return false;
        const start = new Date(selectedStartDate);
        const end = new Date(selectedEndDate);
        const max = new Date(start);
        max.setMonth(max.getMonth() + 3);
        const endOfYear = new Date(new Date().getFullYear(), 11, 31);
        return end >= start && end <= Math.min(max.getTime(), endOfYear.getTime());
    };

    // Column definitions - for Carrier user
    const apptsTitleDD = [
        { id: 'serial_num', name: 'S.No' },
        { id: 'ApptNumber', name: 'Appt Number' },
        { id: 'PoNumber', name: 'PO/SO' },
        { id: 'warehouse', name: 'Warehouse' },
        { id: 'DockName', name: 'Dock' },
        { id: 'ApptStartTime', name: 'Appt Date & Time' },
        { id: 'DueDate', name: 'Due Date' },
        { id: 'PreviousScheduledDate', name: 'Previous Date' },
        { id: 'CurrentScheduledDate', name: 'Current Date' },
        { id: 'RescheduleCount', name: 'Reschedule Count' },
        { id: 'TransDate', name: 'Created On' },
        { id: 'Username', name: 'Rescheduled By' },
        { id: 'Reason', name: 'Reason' },
        { id: 'uploadDocs', name: 'Actions' },
        { id: 'Accordion', name: 'Multi PO/SO' }
    ];

    // Column definitions - for Warehouse user (with/without allowPermission)
    const apptsTitleDDWH = allowPermission ?
        [
            { id: 'serial_num', name: 'S.No' },
            { id: 'ApptNumber', name: 'Appt Number' },
            { id: 'PoNumber', name: 'PO/SO' },
            { id: 'carrier', name: 'Carrier' },
            { id: 'VendorName', name: 'Vendor' },
            { id: 'WarehouseName', name: 'Warehouse' },
            { id: 'DockName', name: 'Dock' },
            { id: 'ApptStartTime', name: 'Appt Date & Time' },
            { id: 'DueDate', name: 'Due Date' },
            { id: 'PreviousScheduledDate', name: 'Previous Date' },
            { id: 'CurrentScheduledDate', name: 'Current Date' },
            { id: 'RescheduleCount', name: 'Reschedule Count' },
            { id: 'TransDate', name: 'Created On' },
            { id: 'Username', name: 'Rescheduled By' },
            { id: 'Reason', name: 'Reason' },
            { id: 'uploadDocs', name: 'Actions' },
            { id: 'Accordion', name: 'Multi PO/SO' }
        ]
        : [
            { id: 'serial_num', name: 'S.No' },
            { id: 'ApptNumber', name: 'Appt Number' },
            { id: 'PoNumber', name: 'PO/SO' },
            { id: 'carrier', name: 'Carrier' },
            { id: 'VendorName', name: 'Vendor' },
            { id: 'DockName', name: 'Dock' },
            { id: 'ApptStartTime', name: 'Appt Date & Time' },
            { id: 'DueDate', name: 'Due Date' },
            { id: 'PreviousScheduledDate', name: 'Previous Date' },
            { id: 'CurrentScheduledDate', name: 'Current Date' },
            { id: 'RescheduleCount', name: 'Reschedule Count' },
            { id: 'TransDate', name: 'Created On' },
            { id: 'Username', name: 'Rescheduled By' },
            { id: 'Reason', name: 'Reason' },
            { id: 'uploadDocs', name: 'Actions' },
            { id: 'Accordion', name: 'Multi PO/SO' }
        ];

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    });

    useEffect(() => {
        dispatch({ type: sagaActions.RESET_APPTS_LIST_ACTION });
        setShowLoading(true);
        setAllApptsArr([]);
    }, []);

    useEffect(() => {
        if (myAppointmentsListResponse && myAppointmentsListResponse.data.length) {
            setShowLoading(false);
            setAllApptsArr(myAppointmentsListResponse.data);
        } else {
            setAllApptsArr([]);
            setShowLoading(false);
        }
    }, [myAppointmentsListResponse]);

    // Fetch appointments based on the filters
    useEffect(() => {
        if (currentFilterSelected && selectedStartDate && selectedEndDate && isValidRange()) {
            fetchAppts(1, PaginationDefaultLimit, searchStr);
        }
    }, [currentFilterSelected, selectedStartDate, selectedEndDate, currentWarehouseFilterSelected]);

    const getWarehouseIDForReportFilter = (currentWarehouseFilterSelected, selectedWarehouse) => {
        if (currentWarehouseFilterSelected?.ID && allowPermission) {
            return currentWarehouseFilterSelected?.ID;
        } else if (!currentWarehouseFilterSelected?.ID && allowPermission) {
            return null;
        } else {
            return selectedWarehouse.ID;
        }
    };

    // Fetch rescheduled live appointments report
    const fetchAppts = (pageNo = 1, limit = PaginationDefaultLimit, searchParams) => {
        setShowLoading(true);
        const apiParams = {
            "ID": userType === 'CARRIER' ? userAccountDetails?.IDCarrier : getWarehouseIDForReportFilter(currentWarehouseFilterSelected, selectedWarehouse),
            "type": userType === 'CARRIER' ? 'carrier' : 'warehouse',
            "pageNo": pageNo,
            "limit": limit,
            "searchParam": searchParams ? searchParams : null,
            "StartDate": selectedStartDate ? getLocalDateString(selectedStartDate) : null,
            "EndDate": selectedEndDate ? getLocalDateString(selectedEndDate) : null,
            "UserTypeFilter": currentFilterSelected?.name === 'All User' ? null : currentFilterSelected.name,
            "CompanyID": allowPermission ? currentWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID : null
        };
        dispatch({ type: sagaActions.GET_RESCHEDULED_LIVE_APPOINTMENTS_REPORT, payload: apiParams });
    };

    const fetchApptsReportHistoryDetails = (apptNumber) => {
        setapptNumber(apptNumber);
        setShowAppointmentHistoryModal(true);
    };

    useEffect(() => {
        if (searchStr && searchStr.length > 3) {
            setTimeout(() => {
                fetchApptList(searchStr);
            }, 1000);
        } else if (searchStr === '') {
            fetchApptList(null);
        }
    }, [searchStr]);

    const fetchApptList = (searchParams = null, pageNo = 1, limit = PaginationDefaultLimit) => {
        fetchAppts(pageNo, limit, searchParams);
    };

    const documentModelHandler = (el) => {
        if (showUploadDocsModal) {
            setapptNumber(null);
        } else {
            setapptNumber(el?.AppointmentNumber);
        }
        setShowUploadDocsModal(!showUploadDocsModal);
    };

    const fetchUploadDocsDataForAppt = () => {
        if (apptNumber) {
            dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: true });
            let fd = new FormData();
            fd.append('AppointmentNumber', apptNumber);
            fd.append('file', null);
            fd.append('docName', null);
            fd.append('ApptDocsCreatedBy', null);
            fd.append('ApptDocsUpdatedBy', null);
            fd.append('CRUDTYPE', 'S');
            dispatch({
                type: sagaActions.UPLOAD_APPT_DOCS,
                payload: { CRUDTYPE: 'S', uploadData: fd }
            });
        }
    };

    const getActions = (el) => {
        return (
            <div className='d-flex justify-content-evenly'>
                <span onClick={() => documentModelHandler(el)}>
                    <i className="fa-solid fa-file text-grey fa-lg" title='Show Attachments'></i>
                </span>
                <span onClick={() => { setSelectedPo(el); setShowPoDetailsModal(true); }}>
                    <i className="fa-solid fa-circle-info text-grey fa-lg" title='Show More Details'></i>
                </span>
            </div>
        );
    };

    const returnRescheduledBy = (el) => {
        return (
            <div className="d-flex flex-column">
                <span>{el.Username || '-'}</span>
                <span>{el.Usertype === 'USER' ? 'Warehouse' : el.Usertype || '-'}</span>
            </div>
        );
    };

    const formatListDataDrillDown = (data) => {
        // data[0] is the main/parent PO record; data[1+] are associated PO accordion child rows
        const mainEl = data[0];

        return data.map((el, index) => {
            // For associated PO child rows (index > 0), fall back to the main record's
            // values for CreatedBy (Username/Usertype), ReasonCode, and Reason when missing
            const effectiveEl = index > 0 ? {
                ...el,
                Username: el.Username || mainEl.Username,
                Usertype: el.Usertype || mainEl.Usertype,
                ReasonCode: el.ReasonCode || mainEl.ReasonCode,
                Reason: el.Reason || mainEl.Reason,
                TransDate: el.TransDate || mainEl.TransDate
            } : el;

            if (userType === 'CARRIER') {
                return {
                    id: el.AppointmentNumber,
                    0: index + 1,
                    1: <span style={{ textDecoration: 'underline', color: 'blue' }} onClick={() => fetchApptsReportHistoryDetails(el.AppointmentNumber)}>{el.AppointmentNumber}</span>,
                    2: el.PoNumber,
                    3: el?.WarehouseNameWithExternalSiteID || '-',
                    4: el.DockName || '-',
                    5: el.ApptStartTime ? moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    6: el.DueDate ? moment(el.DueDate).utc().format('MM/DD/YYYY') : '-',
                    7: el.PreviousScheduledDate ? moment(el.PreviousScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    8: el.CurrentScheduledDate ? moment(el.CurrentScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    9: el.RescheduleCount !== undefined ? el.RescheduleCount : '-',
                    10: effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    11: returnRescheduledBy(effectiveEl),
                    12: effectiveEl.Reason ? effectiveEl.Reason : '-',
                    13: getActions(el)
                };
            } else {
                const getWarehouseColumn = () => {
                    let columns = {
                        id: el.AppointmentNumber,
                        0: index + 1,
                        1: <span style={{ textDecoration: 'underline', color: 'blue' }} onClick={() => fetchApptsReportHistoryDetails(el.AppointmentNumber)}>{el.AppointmentNumber}</span>,
                        2: el.PoNumber,
                        3: el?.CarrierName || '-',
                        4: el.VendorName || '-',
                    };

                    if (allowPermission) {
                        columns[5] = el?.WarehouseNameWithExternalSiteID || '-';
                        columns[6] = el.DockName || '-';
                        columns[7] = el.ApptStartTime ? moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[8] = el.DueDate ? moment(el.DueDate).utc().format('MM/DD/YYYY') : '-';
                        columns[9] = el.PreviousScheduledDate ? moment(el.PreviousScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[10] = el.CurrentScheduledDate ? moment(el.CurrentScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[11] = el.RescheduleCount !== undefined ? el.RescheduleCount : '-';
                        columns[12] = effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[13] = returnRescheduledBy(effectiveEl);
                        columns[14] = effectiveEl.Reason ? effectiveEl.Reason : '-';
                        columns[15] = getActions(el);
                    } else {
                        columns[5] = el.DockName || '-';
                        columns[6] = el.ApptStartTime ? moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[7] = el.DueDate ? moment(el.DueDate).utc().format('MM/DD/YYYY') : '-';
                        columns[8] = el.PreviousScheduledDate ? moment(el.PreviousScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[9] = el.CurrentScheduledDate ? moment(el.CurrentScheduledDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[10] = el.RescheduleCount !== undefined ? el.RescheduleCount : '-';
                        columns[11] = effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[12] = returnRescheduledBy(effectiveEl);
                        columns[13] = effectiveEl.Reason ? effectiveEl.Reason : '-';
                        columns[14] = getActions(el);
                    }

                    return columns;
                };

                return getWarehouseColumn();
            }
        });
    };

    const toggleModal = () => {
        setShowAppointmentHistoryModal(!showAppointmentHistoryModal);
    };

    const formatdata = (data) => {
        if (!data.length) {
            return [];
        }
        let result = data?.map(el => {
            if (el?.associatedPO && el?.associatedPO.length) {
                return [el, ...el?.associatedPO];
            } else {
                return [el];
            }
        });
        const sortedResponse = result.map(subArray => [subArray[0], ..._.orderBy(subArray.splice(1, _.size(subArray) - 1), ['ApptEndTime'], ['asc'])]);
        const finalSortedResponse = _.sortBy(sortedResponse, subArray => subArray[0]?.ApptEndTime);
        return finalSortedResponse;
    };

    const getBodyData = () => {
        if (allApptsArr.length) {
            const formatedData = formatdata(allApptsArr);
            return formatedData.map((data, index) => {
                return formatListDataDrillDown(data, index);
            });
        } else {
            return [];
        }
    };

    const pageChange = (pageNo, limit = PaginationDefaultLimit) => {
        fetchAppts(pageNo, limit, searchStr);
    };

    const downloadData = (type, data) => {
        let payload = {
            heading: "Reschedule Live Appointment report",
            subDomain: "rescheduleliveappointmentsreport",
            downloadType: type,
            fileName: "RescheduleLiveAppointmentReport-" + userAccountDetails?.UserName + "-" + Date.now(),
            options: {
                startDate: null,
                endDate: null,
                ID: userType === 'CARRIER' ? userAccountDetails?.IDCarrier : getWarehouseIDForReportFilter(downloadWarehouseFilterSelected, selectedWarehouse),
                type: userType === 'CARRIER' ? 'carrier' : 'warehouse',
                ApptStatus: 'Rescheduled',
                UserTypeFilter: data?.userTypeFilter === 'All User' ? null : data?.userTypeFilter || null,
                CompanyID: allowPermission ? downloadWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID : null
            },
            userDetails: {
                CUID: userAccountDetails?.CUID,
            }
        };
        return payload;
    };

    const downloadReport = (payload) => {
        dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    };

    const navigate = useNavigate();

    const handleMyReports = () => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
        navigate('/myreports');
    };

    const columnListWarehouse = [
        { name: "Appt Number", value: "AppointmentNumber" },
        { name: "PO", value: "PoNumber" },
        {
            name: "Warehouse",
            value: "WarehouseNameWithExternalSiteID"
        },
        { name: "Carrier", value: "CarrierName" },
        { name: "Vendor", value: "VendorName" },
        { name: "Due Date", value: "DueDate", isDate: true },
        { name: "Created On", value: "TransDate", isDate: true, isTime: true },
        { name: "Appt-Time", value: "ApptStartTime", isDate: true, isTime: true },
        { name: "Dock", value: "DockName" },
        { name: "Previous Date", value: "PreviousScheduledDate", isDate: true, isTime: true },
        { name: "Current Date", value: "CurrentScheduledDate", isDate: true, isTime: true },
        { name: "Reschedule Count", value: "RescheduleCount" },
        { name: "Rescheduled By", value: "Username" },
        {
            name: "Reason-Code",
            value: "ReasonCode"
        },
        { name: "Reason", value: "Reason" },
        { name: "Status", value: "ApptScheStatus" }
    ];

    const columnListCarrier = [
        { name: "Appt Number", value: "AppointmentNumber" },
        { name: "PO", value: "PoNumber" },
        { name: "Warehouse", value: "WarehouseNameWithExternalSiteID" },
        { name: "Vendor", value: "VendorName" },
        { name: "Due Date", value: "DueDate", isDate: true },
        { name: "Created On", value: "TransDate", isDate: true, isTime: true },
        { name: "Appt-Time", value: "ApptStartTime", isDate: true, isTime: true },
        { name: "Dock", value: "DockName" },
        { name: "Previous Date", value: "PreviousScheduledDate", isDate: true, isTime: true },
        { name: "Current Date", value: "CurrentScheduledDate", isDate: true, isTime: true },
        { name: "Reschedule Count", value: "RescheduleCount" },
        { name: "Rescheduled By", value: "Username" },
        {
            name: "Reason-Code",
            value: "ReasonCode"
        },
        { name: "Reason", value: "Reason" },
        { name: "Status", value: "ApptScheStatus" }
    ];

    const showCustomDropDownForFilters = () => {
        const filterDataArr = [
            { name: 'All User' },
            { name: 'Carrier' },
            { name: 'Warehouse' },
        ];
        return (
            <div className='d-flex align-items-center'>
                <CustomDropDown
                    themeSelected={themeSelected}
                    data={filterDataArr}
                    placeHolder={currentFilterSelected?.name}
                    onSelect={(event) => setCurrentFilterSelected(event)}
                    keyStr={'name'}
                />
            </div>
        );
    };

    const closeSelectPopopup = () => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
    };

    return (
        <div className='appointments-report-ss-wrapper p-3'>
            <div className='container-fluid createPo-wrapper-ss my-2 mx-3'>
                <h4>{'Reschedule Live Appointment'}</h4>
                <div className='d-flex justify-content-end align-items-center all-appt-list-action-right'>
                    {/* Date Range Selector Dropdown */}
                    <div className='me-2'>
                        <CustomDropDown
                            themeSelected={themeSelected}
                            data={[
                                { id: 'last30', name: 'Last 30 Days' },
                                { id: 'last60', name: 'Last 60 Days' },
                                { id: 'custom', name: 'Choose Date' },
                            ]}
                            placeHolder={dateRangeMode === 'last30' ? 'Last 30 Days' : dateRangeMode === 'last60' ? 'Last 60 Days' : 'Choose Date'}
                            onSelect={(event) => setDateRangeMode(event.id)}
                            keyStr={'name'}
                            maxChars={15}
                        />
                    </div>
                    {/* Custom date pickers — only visible in 'custom' mode */}
                    {dateRangeMode === 'custom' && (
                        <AppointmentReportSummarySubHeader
                            getData={null}
                            selectedStartDate={selectedStartDate}
                            setSelectedStartDate={setSelectedStartDate}
                            selectedEndDate={selectedEndDate}
                            setSelectedEndDate={setSelectedEndDate}
                        />
                    )}
                    <div className='me-2'>
                        <WarehouseFiltersForReports
                            currentWarehouseFilterSelected={currentWarehouseFilterSelected}
                            setCurrentWarehouseFilterSelected={setCurrentWarehouseFilterSelected}
                            themeSelected={themeSelected}
                        />
                    </div>
                    {currentFilterSelected?.name ?
                        showCustomDropDownForFilters() : ''}
                    <div className='pos-rel ps-2'>
                        <WarehouseSearchSS
                            placeholder={AppConstant.poManagement.searchPOSection.searchTitleStr}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)}
                        />
                    </div>
                    <div className='d-flex align-items-center mx-3'>
                        <DownloadSectionBECustomFeilds
                            isSchedulePro={true}
                            downloadData={downloadData}
                            isLoading={isDownloadLoading}
                            isDisabled={isDownloadLoading}
                            columnList={userType === 'CARRIER' ? columnListCarrier : columnListWarehouse}
                            downloadReport={downloadReport}
                            showEmail={true}
                            emailValue={userAccountDetails && userAccountDetails.Email ? userAccountDetails.Email : ""}
                            showDateRange={true}
                            showApptStatus={true}
                            filterListArr={[{ name: 'Rescheduled', id: 1 }]}
                            allowPermission={allowPermission}
                            showWarehouseFilter={allowPermission}
                            currentWarehouseFilterSelected={downloadWarehouseFilterSelected}
                            setCurrentWarehouseFilterSelected={setDownloadWarehouseFilterSelected}
                            userType={userType}
                            showUserTypeFilter={true}
                            userTypeFilterListArr={[{ name: 'All User', id: 1 }, { name: 'Carrier', id: 2 }, { name: 'Warehouse', id: 3 }]}
                            userTypeFilterTitle='Rescheduled By'
                            defaultStartDate={selectedStartDate}
                            defaultEndDate={selectedEndDate}
                            defaultApptStatus="Rescheduled"
                            defaultUserTypeFilter={currentFilterSelected?.name}
                            onOpenPopup={() => setDownloadWarehouseFilterSelected(currentWarehouseFilterSelected)}
                        />
                    </div>
                </div>
                <p className='text-danger mb-0 text-end' style={{ fontSize: 'small' }}>{AppConstant.appointmentReportSummary.dateFilterDisclaimer}</p>
            </div>
            <div className='allApptsListContainer-ss' ref={divRef}>
                <DrilldownTableSS
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={userType === 'CARRIER' ? apptsTitleDD : apptsTitleDDWH}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    hasCollapsableContent={true}
                    collapsableData={formatdata(allApptsArr)}
                    accordionPrimaryIndex={1}
                    arrangeOrder={arrangeOrder}
                    arrangeKey={arrangeKey}
                    drillDownReport={myAppointmentsList}
                    initiateDrillDownReport={showLoading}
                    loaderArray={allowPermission ? 17 : 15}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'allApptsList' }}
                    showUTCTime={true}
                />
            </div>
            {!_.isEmpty(myAppointmentsListResponse) && myAppointmentsListResponse?.data?.length ?
                <div>
                    <CustomPaginationSS
                        pageChange={(pageNo, limit) => { pageChange(pageNo, limit); }}
                        pageNo={myAppointmentsListResponse.pageNo}
                        pageSize={myAppointmentsListResponse.limit}
                        totalElements={myAppointmentsListResponse.totalElements}
                        totalPages={Math.ceil(myAppointmentsListResponse.totalElements / myAppointmentsListResponse.limit)}
                        last={myAppointmentsListResponse.last}
                        first={myAppointmentsListResponse.first}
                        data={myAppointmentsListResponse.data}
                    />
                </div> : ""}
            {showAppointmentHistoryModal &&
                <ModalSS toggleModal={toggleModal}>
                    <AppointmentReportHistory
                        themeSelected={themeSelected}
                        data={apptNumber}
                    />
                </ModalSS>
            }
            {showUploadDocsModal ? <UploadSproDocumentsPopup showModal={showUploadDocsModal} setCloseModal={setShowUploadDocsModal} uploadDocsHandler={() => { }} docDeleteHandler={() => { }} appointmentDocumentsList={appointmentDocumentsList} showDelete={false} showUpload={false} initateLoading={initateLoading} /> : ''}
            {showPoDetailsModal ? <PoDetailsPopup showModal={showPoDetailsModal} setCloseModal={setShowPoDetailsModal} poData={{ ...selectedPo, WarehouseData: selectedPo?.WarehouseDetails }} initateLoading={initateLoading} /> : ''}
            {isActiveCommanDownloadPopup ? <SSPopup {...popupshowMorePoObj} popupBtnHandler={(btnText) => {
                if (btnText === 'My Reports') {
                    handleMyReports();
                } else {
                    dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
                }
            }} closepopup={closeSelectPopopup} themeSelected={themeSelected} showModal={isActiveCommanDownloadPopup} /> : ''}
        </div>
    );
}

export default RescheduleLiveAppointment;